import RemitServiceLineCard from './RemitServiceLineCard';

export default RemitServiceLineCard;
